import { Eye, Trash2 } from 'lucide-react';

import { NewsItemDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';

interface NewsItemActionHandlers {
  onPreview: (newsItem: NewsItemDTO) => void;
  onDelete: (newsItem: NewsItemDTO) => Promise<void> | void;
}

const createNewsItemActions =
  (handlers: NewsItemActionHandlers) =>
  (row: NewsItemDTO): TableAction[] => {
    const actions: TableAction[] = [];

    actions.push({
      label: 'Preview in Info Hub',
      onClick: () => handlers.onPreview(row),
      icon: <Eye className="w-4 h-4" />,
    });

    // Delete sits here rather than beside Edit: it is destructive and shouldn't be a
    // mis-click away from the row's routine action. No confirmMessage — the list screen's
    // own handler already confirms, and two prompts in a row is worse than one.
    actions.push({
      label: 'Delete News Item',
      onClick: () => handlers.onDelete(row),
      icon: <Trash2 className="w-4 h-4" />,
      className: 'text-red-600 hover:text-red-700',
    });

    return actions;
  };

export default createNewsItemActions;
